import EventEmitter from 'eventemitter3'

export const bus = new EventEmitter()

export default bus

// export default { // TODO: Plugin installation not working will come back to this for now import in to needed components works fine!
//   install (Vue) {
//     Vue.prototype.$bus = bus
//   }
// }
